// WEATHER TIMING — mirrors backend/weather/settings.py WEATHER_TIMING (one place each side;
// GET /api/weather/faces also returns them as `timing`). All times run on the server clock
// from weather_state.drawn_at:
//   0 .. FLIP            the weather card flips over in the overlay (every screen)
//   .. + RESULT_HOLD     the weather result shows in the overlay
//   .. + GLOBAL_CARD     the global card flips next to it (its carbon counts after the weather)
//   .. + REVEAL          the overlay fades out, the area reveal runs on the board:
//                        shape faces = the AREA SHUFFLE (REVEAL, first decoy -> freeze);
//                        Storm Surge / Clear Skies = SHORT_REVEAL (no shuffle)
//   then                 the real area freezes (pulse), the reach outline, then the results
//                        (and Protection prompts) show in the left column (FREEZE_BEAT later);
//                        the round ends by itself RESULTS_HOLD after the answers are in.
export const WEATHER_TIMING_MS = {
  FLIP: 1200,
  RESULT_HOLD: 1500,
  GLOBAL_CARD: 2000,
  REVEAL: 4500, // shape faces: the area shuffle (server: reveal_seconds)
  SHORT_REVEAL: 1200, // Storm Surge / Clear Skies (server: short_reveal_seconds)
  REDUCED_SHUFFLE: 1000, // reduced motion: a few decoys, frozen after ~1 s, then the area simply shows longer
  FREEZE_BEAT: 500, // screen only: the pulse + reach outline before the results appear
  RESULTS_HOLD: 5000,
  OVERLAY_FADE: 350,
};

// Server-supplied timing (seconds) wins when present, so a later change only needs the backend.
export function timingFrom(faces) {
  const t = faces?.timing;
  const ms = (k, d) => (Number.isFinite(Number(t?.[k])) ? Math.round(Number(t[k]) * 1000) : d);
  return {
    ...WEATHER_TIMING_MS,
    FLIP: ms("card_flip_seconds", WEATHER_TIMING_MS.FLIP),
    RESULT_HOLD: ms("result_hold_seconds", WEATHER_TIMING_MS.RESULT_HOLD),
    GLOBAL_CARD: ms("global_card_seconds", WEATHER_TIMING_MS.GLOBAL_CARD),
    REVEAL: ms("reveal_seconds", WEATHER_TIMING_MS.REVEAL),
    SHORT_REVEAL: ms("short_reveal_seconds", WEATHER_TIMING_MS.SHORT_REVEAL),
    RESULTS_HOLD: ms("results_hold_seconds", WEATHER_TIMING_MS.RESULTS_HOLD),
  };
}

// The board reveal for a weather state: the shuffle for shape faces, the short reveal otherwise.
export function revealMsFor(T, ws) {
  return ws?.kind === "shape" ? T.REVEAL : T.SHORT_REVEAL;
}
